<template>
    <div>
        <h5 class="text-secondary">Platform</h5>

        <b-row v-if="!printView">
            <b-col>
                <b-input-group size="sm">
                    <b-form-select size="sm" v-model="component.site" :options="platformOptions" :class="{ 'is-invalid': !component.site }">
                        <template #first>
                            <b-form-select-option :value="undefined" disabled>Platform</b-form-select-option>
                        </template>
                    </b-form-select>

                    <!--<b-link v-if="component.orderId && component.site === 'eBay'" class="form-control text-primary" target="ebayOrder" :href="ebayOrderLink">{{ component.orderId }}</b-link>-->
                    <b-input v-if="component.site !== 'Web' && component.site !== 'Email' && component.site !== 'Phone' && component.site !== 'Walk-In' && component.site !== 'Post' && component.site !== 'Employee'" v-model="component.orderId"></b-input>
                    <b-button size="sm" v-if="platformLink.length > 0" :href="platformLink" target="_blank" variant="outline-secondary"><b-icon-box-arrow-up-right></b-icon-box-arrow-up-right></b-button>
                    
                    <b-input v-if="component.customerId" :value="component.customerId" disabled></b-input>

                    <b-input-group-append v-if="usernameValue">
                        <b-button size="sm" :id="'platformUsername-' + _uid" variant="outline-info">
                            <b-icon-info-circle></b-icon-info-circle>
                        </b-button>

                        <b-tooltip :target="'platformUsername-' + _uid" triggers="hover">
                            {{ usernameValue }}
                        </b-tooltip>
                    </b-input-group-append>

                    <b-input-group-append v-if="component.date">
                        <b-button size="sm" id="platformDate" variant="outline-info">
                            <b-icon-calendar4-event></b-icon-calendar4-event>
                        </b-button>

                        <b-tooltip target="platformDate" triggers="hover">
                            {{ moment(component.date).format('M/D/YYYY h:mma') }}
                        </b-tooltip>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
        </b-row>

        <div v-else>
            <b-row>
                <b-col sm="3">Site</b-col>
                <b-col>{{ platform.site }} <span v-if="location === 'Review'">(Flagged)</span></b-col>
            </b-row>

            <b-row>
                <b-col sm="3">Order</b-col>
                <b-col>
                    {{ platform.orderId }}
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="3">Customer</b-col>
                <b-col>{{ platform.customerId }}</b-col>
            </b-row>

            <b-row v-if="platform.date">
                <b-col sm="3">Date</b-col>
                <b-col>{{ moment(platform.date).format('M/D/YYYY h:mma') }}</b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import objectMixin from "../../mixins/object";
    import platformOptionsMixin from "../../assets/platformOptions";

    export default {
        name: "Platform",
        props: [ 'platform', 'printView', 'location' ],
        mixins: [ objectMixin, platformOptionsMixin ],
        created() {
            this.clone(this.platform);
        },
        computed: {
            platformLink() {
                if (this.platform.site === 'Discogs') {
                    return `${process.env.VUE_APP_DISCOGS_ORDER_URL}${this.platform.orderId}`;
                } else if (this.platform.site === 'Amazon') {
                    return `${process.env.VUE_APP_AMAZON_ORDER_URL}${this.platform.orderId}`;
                } else if (this.platform.site === 'eBay') {
                    return `${process.env.VUE_APP_EBAY_ORDER_URL}${this.platform.orderId}`;
                }

                return '';
            },
            ebayOrderLink() {
                return `${process.env.VUE_APP_EBAY_ORDER_URL}${this.platform.orderId}`;
            },
            usernameValue() {
                if (this.component.site === 'eBay' && this.component.customerId) {
                    return this.component.customerId;
                } else if (this.component.site === 'Discogs' && this.component.customerUsername) {
                    return this.component.customerUsername;
                }
                return null;
            }
        }
    }
</script>

<style scoped>
    .input-group-text {
        width: 8rem;
    }
</style>